"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeAgoShort = exports.getPrettyDate = exports.getTimeAgo = void 0;

var _formatDistanceStrict = _interopRequireDefault(require("date-fns/formatDistanceStrict"));

var _format = _interopRequireDefault(require("date-fns/format"));

var getTimeAgo = function getTimeAgo(created) {
  return created && (0, _formatDistanceStrict["default"])(new Date(created).getTime(), Date.now(), {
    addSuffix: true,
    roundingMethod: "floor"
  });
};

exports.getTimeAgo = getTimeAgo;

var getPrettyDate = function getPrettyDate(created) {
  return created && (0, _format["default"])(new Date(created).getTime(), "yyyy-MM-dd hh:mm:ss");
};

exports.getPrettyDate = getPrettyDate;

var getTimeAgoShort = function getTimeAgoShort(created) {
  var timeAgo = getTimeAgo(created);
  return timeAgo.replace(" year ago", "y").replace(" years ago", "y").replace(" month ago", "mo").replace(" months ago", "mo").replace(" day ago", "d").replace(" days ago", "d").replace(" hour ago", "h").replace(" hours ago", "h").replace(" minute ago", "m").replace(" minutes ago", "m").replace(" second ago", "s").replace(" seconds ago", "s");
};

exports.getTimeAgoShort = getTimeAgoShort;